/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";

class BestDeals extends Component {
  truncateHTML = (html, maxLength) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    let text = div.innerText;
    if (text.length > maxLength) {
      text = text.substring(0, maxLength) + "...";
    }

    return DOMPurify.sanitize(text); // Güvenliği sağlamak için
  };
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0, // Track the active tab index
    };
  }

  setActiveTab = (index) => {
    this.setState({ activeTab: index });
  };

  render() {
    return (
      <div className="section best-deal">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="section-heading">
                <h6>| En İyi Fırsatlar</h6>
                <h2>En İyi Fırsatı Hemen Bulun!</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="tabs-content">
                <div className="row">
                  <div className="nav-wrapper">
                    <ul className="nav nav-tabs" role="tablist">
                      {this.props.featured.map((item, index) => {
                        return (
                          <li
                            className="nav-item"
                            role="presentation"
                            key={`tab-${index}`}
                          >
                            <button
                              className={`nav-link ${
                                this.state.activeTab === index ? "active" : ""
                              }`}
                              id={`tab-${item.type}-${index}`}
                              data-bs-toggle="tab"
                              data-bs-target={`#content-${item.type}-${index}`}
                              type="button"
                              role="tab"
                              aria-controls={`content-${item.type}-${index}`}
                              aria-selected={this.state.activeTab === index}
                              onClick={() => this.setActiveTab(index)}
                            >
                              {item.type}
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <div className="tab-content" id="myTabContent">
                    {this.props.featured.map((item, index) => {
                      return (
                        <div
                          className={`tab-pane fade ${
                            this.state.activeTab === index ? "show active" : ""
                          }`}
                          id={`content-${item.type}-${index}`}
                          role="tabpanel"
                          aria-labelledby={`tab-${item.type}-${index}`}
                          key={`content-${index}`}
                        >
                          <div className="row">
                            <div className="col-lg-3">
                              <div className="info-table">
                                <ul>
                                  {item.price ? (
                                    <li>
                                      <strong>Fiyat : </strong>
                                      {item.price}
                                    </li>
                                  ) : null}

                                  {item.emlakDurumu ? (
                                    <li>
                                      <strong>Emlak Durumu : </strong>
                                      {item.emlakDurumu}
                                    </li>
                                  ) : null}

                                  {item.typicalFeatures
                                    ? Array.isArray(item.typicalFeatures)
                                      ? item.typicalFeatures
                                          .slice(
                                            0,
                                            item.price && item.emlakDurumu
                                              ? 4
                                              : item.price || item.emlakDurumu
                                              ? 5
                                              : 6
                                          )
                                          .map((feature, featureIndex) => {
                                            const [key, value] =
                                              feature.split(":");
                                            return (
                                              <li
                                                key={`feature-${featureIndex}`}
                                              >
                                                <strong>{key}</strong>
                                                {":"}
                                                {value}
                                              </li>
                                            );
                                          })
                                      : item.typicalFeatures
                                          .split(",")
                                          .slice(
                                            0,
                                            item.price && item.emlakDurumu
                                              ? 4
                                              : item.price || item.emlakDurumu
                                              ? 5
                                              : 6
                                          )
                                          .map((feature, featureIndex) => {
                                            const [key, value] =
                                              feature.split(":");
                                            return (
                                              <li
                                                key={`feature-${featureIndex}`}
                                              >
                                                <strong>{key}</strong>
                                                {":"}
                                                {value}
                                              </li>
                                            );
                                          })
                                    : null}
                                </ul>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <img
                                src={`${
                                  process.env.REACT_APP_API_URL
                                }/api/files/?filepath=${
                                  item.image && item.image[0]
                                }`}
                                alt=""
                              />
                            </div>
                            <div className="col-lg-3">
                              <h4>Gayrimenkul Hakkında Ek Bilgi</h4>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: this.truncateHTML(item.aciklama, 270),
                                }}
                              />

                              <Link to={`/ilan-detay?id=${item.id}`}>
                                <div className="icon-button">
                                  <a href="property-details.html">
                                    <i className="fa fa-search"></i> İlanı
                                    incele
                                  </a>
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BestDeals;
